import React from 'react';

const CarouselItem = (props) => {
    
    const displayPopupOnClick = (props) =>{
        console.log("clickImage in CarouselItem:::",props);
        props.onClick(props);
    }
    return (
        <>
            <div className={props.className}>
                {/* <img src={props.image} onClick={displayPopupOnClick} alt=""/> */}
                <img src={props.image} onClick={()=>displayPopupOnClick(props)} alt=""/>
                <div className="label"> {props.NameofDish}</div>
                <div className="title"> {props.title}</div>
            </div>
        </>
    );
}

export default CarouselItem;